/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ strong: NonNullable<unknown> }} Misc_Posts_Expectlist_Vehicles1Inputs */

const id_misc_posts_expectlist_vehicles1 = /** @type {(inputs: Misc_Posts_Expectlist_Vehicles1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🚀 ${i?.strong}: Terbangkan kapal ikonik seperti Millennium Falcon dan TIE Fighters.`)
};

const ms_misc_posts_expectlist_vehicles1 = /** @type {(inputs: Misc_Posts_Expectlist_Vehicles1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🚀 ${i?.strong}: Terbangkan kapal ikonik seperti Millennium Falcon dan TIE Fighters.`)
};

const da_misc_posts_expectlist_vehicles1 = /** @type {(inputs: Misc_Posts_Expectlist_Vehicles1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🚀 ${i?.strong}: Flyv ikoniske skibe som Millennium Falcon og TIE Fighters.`)
};

const de_misc_posts_expectlist_vehicles1 = /** @type {(inputs: Misc_Posts_Expectlist_Vehicles1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🚀 ${i?.strong}: Fliegen Sie ikonische Schiffe wie den Millennium Falken und TIE-Jäger.`)
};

const en_us2_misc_posts_expectlist_vehicles1 = /** @type {(inputs: Misc_Posts_Expectlist_Vehicles1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🚀 ${i?.strong}: Fly iconic ships like the Millennium Falcon and TIE Fighters.`)
};

const es_es2_misc_posts_expectlist_vehicles1 = /** @type {(inputs: Misc_Posts_Expectlist_Vehicles1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🚀 ${i?.strong}: Vuela naves icónicas como el Halcón Milenario y los cazas TIE.`)
};

const es_mx2_misc_posts_expectlist_vehicles1 = /** @type {(inputs: Misc_Posts_Expectlist_Vehicles1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🚀 ${i?.strong}: Vuela naves icónicas como el Halcón Milenario y los cazas TIE.`)
};

const fil_misc_posts_expectlist_vehicles1 = /** @type {(inputs: Misc_Posts_Expectlist_Vehicles1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.strong}: Lumipad sa mga iconic na sasakyan tulad ng Millennium Falcon at TIE Fighters.`)
};

const fr_misc_posts_expectlist_vehicles1 = /** @type {(inputs: Misc_Posts_Expectlist_Vehicles1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🚀 ${i?.strong} : Pilotez des vaisseaux iconiques comme le Faucon Millenium et les chasseurs TIE.`)
};

const it_misc_posts_expectlist_vehicles1 = /** @type {(inputs: Misc_Posts_Expectlist_Vehicles1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.strong}: Vola su navi iconiche come il Millennium Falcon e i caccia TIE.`)
};

const hu_misc_posts_expectlist_vehicles1 = /** @type {(inputs: Misc_Posts_Expectlist_Vehicles1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.strong}: Repülj ikonikus űrhajókkal, mint az Ezeréves Sólyom és TIE Vadászok.`)
};

const nl_misc_posts_expectlist_vehicles1 = /** @type {(inputs: Misc_Posts_Expectlist_Vehicles1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.strong}: Vlieg iconische schepen zoals de Millennium Falcon en TIE Fighters.`)
};

const no_misc_posts_expectlist_vehicles1 = /** @type {(inputs: Misc_Posts_Expectlist_Vehicles1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.strong}: Fly ikoniske skip som Millennium Falcon og TIE Fighters.`)
};

const pl_misc_posts_expectlist_vehicles1 = /** @type {(inputs: Misc_Posts_Expectlist_Vehicles1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🚀 ${i?.strong}: Lataj kultowymi statkami, takimi jak Sokół Millennium i myśliwce TIE.`)
};

const pt_br2_misc_posts_expectlist_vehicles1 = /** @type {(inputs: Misc_Posts_Expectlist_Vehicles1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🚀 ${i?.strong}: Voe em navios icônicos como o Millennium Falcon e os TIE Fighters.`)
};

const pt_misc_posts_expectlist_vehicles1 = /** @type {(inputs: Misc_Posts_Expectlist_Vehicles1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🚀 ${i?.strong}: Voie naves icónicas como a Millennium Falcon e os caças TIE.`)
};

const ro_misc_posts_expectlist_vehicles1 = /** @type {(inputs: Misc_Posts_Expectlist_Vehicles1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🚀 ${i?.strong}: Zboară cu nave iconice precum Millennium Falcon și TIE Fighters.`)
};

const fi_misc_posts_expectlist_vehicles1 = /** @type {(inputs: Misc_Posts_Expectlist_Vehicles1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🚀 ${i?.strong}: Lennä ikonisilla aluksilla, kuten Millennium Falcon ja TIE-hävittäjät.`)
};

const sv_misc_posts_expectlist_vehicles1 = /** @type {(inputs: Misc_Posts_Expectlist_Vehicles1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🚀 ${i?.strong}: Flyg ikoniska skepp som Millennium Falcon och TIE-fighters.`)
};

const vi_misc_posts_expectlist_vehicles1 = /** @type {(inputs: Misc_Posts_Expectlist_Vehicles1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🚀 ${i?.strong}: Lái những con tàu mang tính biểu tượng như Millennium Falcon và TIE Fighters.`)
};

const tr_misc_posts_expectlist_vehicles1 = /** @type {(inputs: Misc_Posts_Expectlist_Vehicles1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🚀 ${i?.strong}: Millennium Falcon ve TIE Fighters gibi ikonik gemileri uçurun.`)
};

const cs_misc_posts_expectlist_vehicles1 = /** @type {(inputs: Misc_Posts_Expectlist_Vehicles1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🚀 ${i?.strong}: Leťte s ikonickými loděmi jako Millennium Falcon a TIE Fighters.`)
};

const bg_misc_posts_expectlist_vehicles1 = /** @type {(inputs: Misc_Posts_Expectlist_Vehicles1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🚀 ${i?.strong}: Пилотирайте емблематични кораби като Millennium Falcon и TIE Fighters.`)
};

const ru_misc_posts_expectlist_vehicles1 = /** @type {(inputs: Misc_Posts_Expectlist_Vehicles1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🚀 ${i?.strong}: Пилотируйте культовые корабли, такие как «Тысячелетний сокол» и TIE-истребители.`)
};

const uk_misc_posts_expectlist_vehicles1 = /** @type {(inputs: Misc_Posts_Expectlist_Vehicles1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🚀 ${i?.strong}: Літайте на культових кораблях, як-от Тисячолітній Сокіл та TIE-винищувачі.`)
};

const ar_misc_posts_expectlist_vehicles1 = /** @type {(inputs: Misc_Posts_Expectlist_Vehicles1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🚀 ${i?.strong}: حلق بسفن أيقونية مثل Millennium Falcon و TIE Fighters.`)
};

const hi_misc_posts_expectlist_vehicles1 = /** @type {(inputs: Misc_Posts_Expectlist_Vehicles1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🚀 ${i?.strong}: प्रतिष्ठित जहाजों को उड़ाएँ।`)
};

const th_misc_posts_expectlist_vehicles1 = /** @type {(inputs: Misc_Posts_Expectlist_Vehicles1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🚀 ${i?.strong}: ขับยานอวกาศที่เป็นสัญลักษณ์อย่าง Millennium Falcon และ TIE Fighters`)
};

const ja_misc_posts_expectlist_vehicles1 = /** @type {(inputs: Misc_Posts_Expectlist_Vehicles1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🚀 ${i?.strong}：ミレニアム・ファルコンやTIEファイターなどの象徴的な船を操縦。`)
};

const zh_cn2_misc_posts_expectlist_vehicles1 = /** @type {(inputs: Misc_Posts_Expectlist_Vehicles1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🚀 ${i?.strong}：驾驶千岁鹰号和TIE战机等经典飞船。`)
};

const zh_hant1_misc_posts_expectlist_vehicles1 = /** @type {(inputs: Misc_Posts_Expectlist_Vehicles1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.strong}：駕駛千年鷹號和TIE戰機等經典飛船。`)
};

const ko_misc_posts_expectlist_vehicles1 = /** @type {(inputs: Misc_Posts_Expectlist_Vehicles1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.strong}: Millennium Falcon, TIE Fighters 등 상징적인 함선을 조종하세요.`)
};

/**
* | output |
* | --- |
* | "🚀 {strong}: Fly iconic ships like the Millennium Falcon and TIE Fighters." |
*
* @param {Misc_Posts_Expectlist_Vehicles1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const misc_posts_expectlist_vehicles1 = /** @type {((inputs: Misc_Posts_Expectlist_Vehicles1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Misc_Posts_Expectlist_Vehicles1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_misc_posts_expectlist_vehicles1(inputs)
	if (locale === "ms") return ms_misc_posts_expectlist_vehicles1(inputs)
	if (locale === "da") return da_misc_posts_expectlist_vehicles1(inputs)
	if (locale === "de") return de_misc_posts_expectlist_vehicles1(inputs)
	if (locale === "en-US") return en_us2_misc_posts_expectlist_vehicles1(inputs)
	if (locale === "es-ES") return es_es2_misc_posts_expectlist_vehicles1(inputs)
	if (locale === "es-MX") return es_mx2_misc_posts_expectlist_vehicles1(inputs)
	if (locale === "fil") return fil_misc_posts_expectlist_vehicles1(inputs)
	if (locale === "fr") return fr_misc_posts_expectlist_vehicles1(inputs)
	if (locale === "it") return it_misc_posts_expectlist_vehicles1(inputs)
	if (locale === "hu") return hu_misc_posts_expectlist_vehicles1(inputs)
	if (locale === "nl") return nl_misc_posts_expectlist_vehicles1(inputs)
	if (locale === "no") return no_misc_posts_expectlist_vehicles1(inputs)
	if (locale === "pl") return pl_misc_posts_expectlist_vehicles1(inputs)
	if (locale === "pt-BR") return pt_br2_misc_posts_expectlist_vehicles1(inputs)
	if (locale === "pt") return pt_misc_posts_expectlist_vehicles1(inputs)
	if (locale === "ro") return ro_misc_posts_expectlist_vehicles1(inputs)
	if (locale === "fi") return fi_misc_posts_expectlist_vehicles1(inputs)
	if (locale === "sv") return sv_misc_posts_expectlist_vehicles1(inputs)
	if (locale === "vi") return vi_misc_posts_expectlist_vehicles1(inputs)
	if (locale === "tr") return tr_misc_posts_expectlist_vehicles1(inputs)
	if (locale === "cs") return cs_misc_posts_expectlist_vehicles1(inputs)
	if (locale === "bg") return bg_misc_posts_expectlist_vehicles1(inputs)
	if (locale === "ru") return ru_misc_posts_expectlist_vehicles1(inputs)
	if (locale === "uk") return uk_misc_posts_expectlist_vehicles1(inputs)
	if (locale === "ar") return ar_misc_posts_expectlist_vehicles1(inputs)
	if (locale === "hi") return hi_misc_posts_expectlist_vehicles1(inputs)
	if (locale === "th") return th_misc_posts_expectlist_vehicles1(inputs)
	if (locale === "ja") return ja_misc_posts_expectlist_vehicles1(inputs)
	if (locale === "zh-CN") return zh_cn2_misc_posts_expectlist_vehicles1(inputs)
	if (locale === "zh-Hant") return zh_hant1_misc_posts_expectlist_vehicles1(inputs)
	return ko_misc_posts_expectlist_vehicles1(inputs)
});
export { misc_posts_expectlist_vehicles1 as "misc.posts.expectList.vehicles" }